import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['video'];
  static values = { useHls: Boolean };
  declare videoTarget: HTMLVideoElement;
  declare useHlsValue: boolean;
  declare HlsImport: Promise<typeof import('hls.js')>;

  connect(): void {
    if (this.useHlsValue) {
      this.HlsImport = import('hls.js');
    }
  }

  async play(): Promise<void> {
    try {
      this.videoTarget.controls = true;
      if (this.useHlsValue) {
        await this.attachHlsMedia();
      }
      this.videoTarget.play();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  async attachHlsMedia(): Promise<void> {
    const Hls = (await this.HlsImport).default;
    if (!Hls.isSupported()) return;

    const hlsSource = this.videoTarget.src;
    const hls = new Hls();
    hls.attachMedia(this.videoTarget);
    hls.on(Hls.Events.MEDIA_ATTACHED, () => {
      hls.loadSource(hlsSource);
    });
  }
}
